
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/[recipeUrl]",
      function () {
        return require("private-next-pages/recipes/[recipeUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/[recipeUrl]"])
      });
    }
  